import { render } from "./TypeField.vue?vue&type=template&id=e8aabb12"
import script from "./TypeField.vue?vue&type=script&lang=js"
export * from "./TypeField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__